module.exports = __webpack_public_path__ + "assets/d40241e196e344e580ab790a537d025b.png";